(function () {
    'use strict';

    angular.module("imApp").factory("poLoadPlanService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3674,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
